import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
	SearchResponse,
	UserNotificationListRequest,
	UserNotificationModel
} from '@twrx-api-models';

import { HttpApiService } from '../base/http-api.service';
import { UserNotificationApiRoutes } from '../api-routes';

@Injectable()
export class UserNotificationApiService {
	constructor(private readonly httpApiService: HttpApiService) {}

	public list(
		request: UserNotificationListRequest,
		cancellationSubject?: Observable<void>
	): Observable<SearchResponse<UserNotificationModel>> {
		return this.httpApiService.get<SearchResponse<UserNotificationModel>>(
			UserNotificationApiRoutes.Root,
			request,
			cancellationSubject
		);
	}

	public unreadCount(
		cancellationSubject: Observable<void>
	): Observable<number> {
		return this.httpApiService.get<number>(
			`${UserNotificationApiRoutes.Root}/${UserNotificationApiRoutes.UnreadCount}`,
			null,
			cancellationSubject
		);
	}

	public markRead(
		ids: number[],
		cancellationSubject: Observable<void>
	): Observable<void> {
		return this.httpApiService.post<void>(
			`${UserNotificationApiRoutes.Root}/${UserNotificationApiRoutes.MarkRead}`,
			ids,
			cancellationSubject
		);
	}

	public markAllRead(
		cancellationSubject: Observable<void>
	): Observable<void> {
		return this.httpApiService.post<void>(
			`${UserNotificationApiRoutes.Root}/${UserNotificationApiRoutes.MarkAllRead}`,
			null,
			cancellationSubject
		);
	}

	public delete(
		id: number,
		cancellationSubject: Observable<void>
	): Observable<void> {
		return this.httpApiService.delete<void>(
			UserNotificationApiRoutes.Root,
			id,
			cancellationSubject
		);
	}

	public deleteAllRead(
		cancellationSubject: Observable<void>
	): Observable<void> {
		return this.httpApiService.post<void>(
			`${UserNotificationApiRoutes.Root}/${UserNotificationApiRoutes.DeleteAllRead}`,
			null,
			cancellationSubject
		);
	}
}
